import React, { useContext, useEffect, useState } from "react";
import Margin from "canvas-core-react/lib/Margin";
import { getComponent } from "../../utils/getComponent";

interface StepProps {

  steps: any[];
  step: number;
}

export const Step = ({ steps, step }: StepProps) => {
  const [nextStep, setNextStep] = useState<any>();
  const [allComponents, setAllComponents] = useState<any>([]);

  useEffect(() => {

    const stepNow =
      steps !== undefined && step <= steps.length
        ? steps.filter((s: any) => s.step === step)
        : "";

    if (stepNow !== "" && stepNow.length > 0) {
      newComponent(stepNow[0].components);
    }
  }, []);
  const newComponent = (components: any, index: number = 0) => {
    const delay = 500;
    if (index < components.length) {
      if (components[index].type === "info") {
        const draw = getComponent(components[index]);
        setAllComponents((prevState: any) => [...prevState, draw]);

        setTimeout(() => {
          newComponent(components, index + 1);
        }, delay);
      } else if (components[index].type === "input") {
        const draw = getComponent({
          ...components[index],
          onClickParent: onClickInput,
          stepNumber: step,
          indexComponent: index,
        });
        setAllComponents((prevState: any) => [...prevState, draw]);
      }
      else if (components[index].type === "condition") {
        const draw = getComponent({
          ...components[index],
          onClickParent: onClickCondition,
          stepNumber: step,
          indexComponent: index,
        });
        setAllComponents((prevState: any) => [...prevState, draw]);
      }
      else if (components[index].type === "clean") {
        let x = 0;
        const numComponents =
          window.document.getElementsByClassName("component").length;
        while (x < numComponents) {
          window.document.getElementsByClassName("component")[0].remove();
          x++;
        }

        setTimeout(() => {
          newComponent(components, index + 1);
        }, delay);
      }
      else if (components[index].type === "system-end") {
        const draw = getComponent({ ...components[index] });
        setAllComponents((prevState: any) => [...prevState, draw]);
      }
    } else {
      if (step + 1 < steps.length) {
        const nextComponents = getComponent({
          name: "step",
          type: "block",
          title: "",
          contenido: "",
          inputs: {} as any,
          steps,
          stepNumber: getNextStep(steps, step),
        });
        setNextStep(nextComponents);
      }

    }

    setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 0);
  };
  const getNextStep = (steps: any[], stepNow: number) => {
    const filter = steps.filter((s: any) => s.step === stepNow);
    if (filter.length > 0) {
      return parseInt(filter[0]["select-option-condition"]["0"]["next-step"]);
    }
  }
  const onClickInput = (event: any) => {
    const target = event.target.parentElement as HTMLElement;
    const index = target.getAttribute("data-index");

    let stepInput = target.getAttribute("data-step");

    const stepNow =
      steps !== undefined && parseInt(stepInput as string) <= steps.length
        ? steps.filter((s: any) => s.step === parseInt(stepInput as string))
        : "";

    if (stepNow !== "" && stepNow.length > 0) {
      if (stepNow[0].components[parseInt(index as string) + 1] !== undefined) {
        newComponent(stepNow[0].components, parseInt(index as string) + 1);
      } else {
        const nextComponents = getComponent({
          name: "step",
          type: "block",
          title: "",
          contenido: "",
          inputs: {} as any,
          steps,
          stepNumber: getNextStep(steps, parseInt(stepInput ? stepInput : "0")),
        });
        setNextStep(nextComponents);
      }
    }
  };
  const onClickCondition = (event: any) => {
    const target = event.target.parentElement as HTMLElement;
    const index = target.getAttribute("data-index");
    let stepInput = target.getAttribute("data-step");

    const stepResult = getStep(parseInt(stepInput as string));

    const nextStep =
      stepResult["select-option-condition"][index !== null ? index : 0][
      "next-step"
      ];


    const nextComponents = getComponent({
      name: "step",
      type: "block",
      title: "",
      contenido: "",
      inputs: {} as any,
      steps,
      stepNumber: nextStep,
    });
    setNextStep(nextComponents);
  };

  const getStep = (index: any) => {
    const stepsFilter = steps.filter((s) => s.step === parseInt(index));

    if (stepsFilter.length > 0) {
      return stepsFilter[0];
    }
    return null;
  };
  return (
    <>

      {allComponents.map((component: any, index: number) => {
        return <div key={`${step}${index}`}>{component}</div>;
      })}
      {step <= steps.length ? nextStep : ""}

    </>
  );
};
